import styled from "styled-components"
import theme from "@irati/ui/src/global/theme"

interface StyledProps {
  selected: boolean
}

const CustomTrophyWrapper = styled<StyledProps, "div">("div")`
  cursor: pointer;
  display: flex;
  height: 120px;
  align-items: center;
  min-width: 90px;
  padding: ${theme.spacing.one};
  ${({selected}) => selected && `
    background-color: ${theme.colors.greys.lightest}
  `}
`

export default CustomTrophyWrapper
